const shouldShowContentAdvisoryBanner = (content, userProperties) => {
  const veiled = content?.veiled?.[0];
  const { isParent, isStudent } = userProperties;
  const shouldViewBanner = !isStudent && !isParent;

  if (!veiled) {
    return false;
  }

  return veiled.reason === "DISTRICT_ADVISORY" && shouldViewBanner;
};

export default shouldShowContentAdvisoryBanner;
